import { capitalizeField, toBoolean, upperCaseField } from './prettifyField';

export const prettifyPolicy = {
  lastname: upperCaseField,
  nom: upperCaseField,
  nomlivraison: upperCaseField,
  lyceeName: upperCaseField,
  classeName: upperCaseField,
  nomsociete: upperCaseField,
  firstname: capitalizeField,
  prenomlivraison: capitalizeField,
  prenom: capitalizeField,
  adresse: upperCaseField,
  adressefacturation: upperCaseField,
  adresselivraison: upperCaseField,
  ville: upperCaseField,
  villefacturation: upperCaseField,
  villelivraison: upperCaseField,
  livraisonhorslycee: toBoolean,
  clientpro: toBoolean,
  policy: toBoolean
};
